let quantityState = {};

function updateQuantity(line, quantity) {
  const body = JSON.stringify({
    line,
    quantity,
    sections: getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname,
  });

  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => response.text())
    .then((state) => {
      const parsedState = JSON.parse(state);
      if (parsedState.errors) {
        console.error("Error updating quantity:", parsedState.errors);
        return;
      }
      getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });
      if (typeof window.addCartToggleEvents != "undefined") {
        addCartToggleEvents();
      }
    })
    .catch((error) => {
      console.error("Error updating quantity:", error);
    });
}

const debouncedUpdateQuantity = debounce((line, quantity) => {
  const lineItem = document.querySelector(`[data-cart-line-item="${line}"]`);
  lineItem
    .querySelectorAll("[data-input-toggle]")
    .forEach((el) => (el.disabled = true));
  lineItem
    .querySelectorAll("[data-cart-input-loader]")
    .forEach((el) => el.classList.remove("hidden"));
  updateQuantity(line, quantity);
}, 500);

function handleQuantityChange(line, change, inventory) {
  const quantityDisplay = document.getElementById(`quantity-display-${line}`);

  if (!quantityState[line]) {
    quantityState[line] = parseInt(quantityDisplay.innerText, 10);
  }

  let newQuantity = quantityState[line] + change;

  if (change > 0 && newQuantity > inventory) {
    newQuantity = inventory;
  }

  if (newQuantity <= 0) {
    quantityState[line] = 0;
  } else {
    quantityState[line] = newQuantity;
  }

  quantityDisplay.innerText = quantityState[line];
  debouncedUpdateQuantity(line, quantityState[line]);
}

function getSectionsToRender() {
  const sections = [
    // Header cart icon
    {
      id: "header",
      section: document.getElementById("header").dataset.id,
      selector: ".cart-icon-update",
    },
  ];

  if (window.location.pathname === "/cart") {
    sections.push(
      {
        id: "new-main-cart-items",
        section: document.getElementById("new-main-cart-items").dataset.id,
        selector: "[data-cart-items]",
      },
      {
        id: "main-cart-header",
        section: document.getElementById("main-cart-header").dataset.id,
        selector: ".cart-header-update",
      },
      {
        id: "cart-page-footer",
        section: document.getElementById("cart-page-footer").dataset.id,
        selector: ".cart-footer-update",
      }
    );
  } else {
    sections.push(
      // Cart drawer
      {
        id: "header",
        section: document.getElementById("header").dataset.id,
        selector: ".cart-drawer-update",
      }
    );
  }

  return sections;
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector).innerHTML;
}
